import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { setHeaderTitle } from "../../helpers/header.helper";
import { AppState } from "../../reducers/models";
import PageHeader from "./page-header.component";
import { pageTitles } from "./constants";
import { PageNotFoundIcon } from "../../icon";
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';
interface IProps {
    // IsMobileDevice: boolean
}

const PageNotFoundComponent = (props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    useEffect(() => {
        setHeaderTitle(pageTitles.PAGE_NOT_FOUND)
        return () => {
            setHeaderTitle()
        }
    }, [])

    return (
        <Grid container className="bg-color-conv-hist-bg h-p-100 justify-center d-flex page-not-found-border my-0">
            {
                IsMobileDevice &&
                <PageHeader ErrPage={true} Count={0} HideSearch={true} />
            }

            <div className={`m-auto ${IsMobileDevice && 'h-v-90 d-flex justify-center p-2'}`}>
                <PageNotFoundIcon className="w-p-100" />
            </div>
        </Grid>
    );

}


export default PageNotFoundComponent;